"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[9806],{

/***/ 9806:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CollectionVideoPlayer)
/* harmony export */ });
function CollectionVideoPlayer() {
  if (!customElements.get('collection-video-player')) {
    customElements.define(
      'collection-video-player',
      class CustomDialog extends HTMLElement {
        constructor() {
          super()
          this.video = this.querySelector('video')
          this.playButton = this.querySelector('button')
          this.togglePlay = this.togglePlay.bind(this)
          this.playButton.addEventListener('click', this.togglePlay)
        }

        togglePlay() {
          const { video, playButton } = this
          if (video.paused) {
            video.play()
            playButton.dataset.isPlaying = 'true'
          } else {
            video.pause()
            playButton.dataset.isPlaying = 'false'
          }
        }
      }
    )
  }
}


/***/ })

}]);